import React, { useEffect, useContext } from 'react'
import ScrollToTop from '../../../Shared/ScrollToTop';
import { NavLink } from 'react-router-dom';
import CompaniesImg from './../../../../assets/images/wecourier-saas/pages/companies.png';
import { ProjectTypeContext } from '../../../../ContextHandle';
export default function Companies({ setActivePage, sectionRefs, setDefaultWebActiveMenu }) {
 /* eslint-disable */
    var projectType = useContext(ProjectTypeContext); 
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(2002);
        document.title = 'Companies | ' + projectName + ' web';
        setDefaultWebActiveMenu(4);
    }, [projectName]);

    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}/introduction`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">Admin Panel</li>
                        <li className="breadcrumb-item active" aria-current="page">Companies</li>
                    </ol>
                </nav>
                <div id="dashboards" ref={sectionRefs['4']}>
                    <h4 className="font-weight-bold mt-5  ">Companies</h4>
                    <div className='pt-3'>
                        <img src={CompaniesImg} className="w-100 rounded" alt="Companies"></img>
                    </div>

                    <p className="pt-3">Admin can create panel for company with sub-domain and module access through plan. The company can give its information on its sub-domain site as it likes. And can use its merchant.</p>

                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/admin/dashboard`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Dashboard</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/admin/plans`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Plans</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
